import { RouteConfig } from "@abaco/web-common/src/app";

const routes: RouteConfig[] = [
    {
        name: "pedology-home",
        path: "/pedology-home",
        component: () => import("./components/PedologyContainer.vue"),
        meta: {
            navbarItems: [
                { component: "farm-select-nav-bar-item", props: { isRequired: true } },
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
            ],
        },
    },
];

export default routes;
